import type { MoneyMap } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useDuplicateMoneyMap = requestBuilder.mutation<
    MoneyMap,
    undefined,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/money-map/${id}/duplicate`,
    method: 'POST',
});
